module.exports = __webpack_public_path__ + "assets/img/speaker.a39cbbc9.svg";